import React from 'react';
import { Translations } from '../i18n/translations';
import { CrownStarIcon } from './icons';
import { getBestSellers } from '../data/products';
import { PlaceholderImage } from './PlaceholderImage';
interface BestSellersProps {
  t: Translations;
  setPage: (page: 'home' | 'product', slug?: string) => void;
}
export const BestSellers: React.FC<BestSellersProps> = ({
  t,
  setPage
}) => {
  const products = getBestSellers();
  return <section id="best-sellers" className="bg-cream py-24 border-t border-gold/10" data-id="element-7">
      <div className="max-w-7xl mx-auto px-4 lg:px-8" data-id="element-8">
        <div className="flex flex-col items-center mb-16" data-id="element-9">
          <h2 className="text-3xl lg:text-4xl font-serif text-ink mb-6 text-center" data-id="element-10">
            {t.bestSellers.title}
          </h2>
          <div className="w-24 h-[1px] bg-gold" data-id="element-11"></div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12 lg:gap-x-8 lg:gap-y-16" data-id="element-12">
          {products.map((p, i) => <div key={i} className="group flex flex-col" data-id="element-13">
              {/* Image Container */}
              <div className="product-image-wrapper relative aspect-square rounded-sm mb-6 overflow-hidden cursor-pointer flex items-center justify-center" onClick={() => setPage('product', p.slug)} data-id="element-14">
                <PlaceholderImage silhouette={p.images[0].silhouette} className="product-image absolute inset-0 w-full h-full group-hover:scale-105 transition-transform duration-500" data-id="element-15" />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-ink/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-16">
                  <span className="bg-white/90 text-ink px-6 py-3 text-xs uppercase tracking-widest rounded-sm transform translate-y-4 group-hover:translate-y-0 transition-all duration-300" data-id="element-17">
                    {t.bestSellers.viewProduct}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="flex flex-col flex-1" data-id="element-18">
                <span className="text-[10px] uppercase tracking-widest text-gold mb-2" data-id="element-19">
                  REF {p.ref}
                </span>
                <h3 className="font-serif text-lg text-ink mb-2 cursor-pointer hover:text-gold transition-colors line-clamp-2" onClick={() => setPage('product', p.slug)} data-id="element-20">
                  {p.name.es}
                </h3>

                <div className="flex items-center space-x-1 mb-4 text-gold" data-id="element-21">
                  {[...Array(5)].map((_, j) => <CrownStarIcon key={j} className="w-3 h-3" data-id="element-22" />)}
                  <span className="text-xs text-ink/40 ml-2" data-id="element-23">(12)</span>
                </div>

                <div className="flex items-center space-x-3 mb-6 mt-auto" data-id="element-24">
                  <span className="text-lg font-serif text-ink" data-id="element-25">
                    ${p.price}
                  </span>
                  {p.comparePrice && <span className="text-sm text-ink/40 line-through" data-id="element-26">
                      ${p.comparePrice}
                    </span>}
                </div>

                <button onClick={() => setPage('product', p.slug)} className="w-full border border-gold text-gold py-3 text-xs lg:text-sm uppercase tracking-widest hover:bg-gold hover:text-ink transition-soft rounded-sm" data-id="element-27">
                  {t.bestSellers.addToRecovery}
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};